module.exports = __webpack_public_path__ + "img/23EA.8469d7e5.svg";